import React from "react";
import ProductImage from "./ProductImage";
import BadgesPDP from "./BadgesPDP";

const ProductImageBlock = (props) => {
  const {product} = props;

  return <div className="position-relative">
    <BadgesPDP product={product}/>
    <ProductImage image={product?.image?.lg}/>
  </div>;
};

export default ProductImageBlock;
